import { useSelector } from 'react-redux';

import { useLocalization } from 'redux/localization/utils/hooks';

const NoItems = () => {
  const settings = useSelector((state) => state.setting.data);
  const cartReducer = useSelector((state) => state.cart);
  const { t } = useLocalization();
  if (cartReducer.skuBeingAdded) {
    return null;
  }

  return (
    <>
      <div className="c7-notice--empty">
        <div
          role="status"
          dangerouslySetInnerHTML={{
            __html: t('checkout.general.emptyCartMessage')
          }}
        />
        <a href={settings.continueShopping} className="c7-btn c7-btn--primary">
          {t('checkout.general.startShopping')}
        </a>
      </div>
      <div className="c7-order-items" />
    </>
  );
};

export default NoItems;
